class RcsUtils {
  static fetchJson(url, callback, errorCallback = null) {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          if (typeof errorCallback === 'function') {
            errorCallback();
          }

          return `Failed fetching data. Reason: ${response.statusText}`;
        }
        return response.json();
      })
      .then(data => {
        if (typeof callback === 'function') {
          callback(data);
        }
      })
      .catch(error => {
        throw new Error(`Failed fetching data. Reason: ${error}`);
      });
  }

  static fetchText(url, callback, errorCallback = null) {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          if (typeof errorCallback === 'function') {
            errorCallback();
          }

          return `Failed fetching data. Reason: ${response.statusText}`;
        }

        return response.arrayBuffer();
      })
      .then(data => {
        if (typeof callback === 'function') {
          callback(data);
        }
      })
      .catch(error => {
        throw new Error(`Failed fetching data. Reason: ${error}`);
      });
  }

  static getDevice() {
    let device = 'desktop';

    if (document.querySelector('#device') !== null) {
      device = document.querySelector('#device').innerText;
    }

    return device;
  }

  static getUUID() {
    let uuid = null;
    let contentToRead = document.querySelector('#content-to-read');
    if (contentToRead !== null) {
      uuid = contentToRead.getAttribute('rel');
    }

    if (uuid === null) {
      if (typeof window.uuid_articolo !== 'undefined') {
        uuid = window.uuid_articolo;
      }
    }

    return uuid;
  }
}

module.exports = RcsUtils;



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/utils/RcsUtils.js